function pathchLevels (sourceText, column) {
  const originText = String(sourceText).split(column.delimiter || '/')
  const originTextLength = originText.length
  let diffNum = Math.abs(column.TextFlexMaxLevel || 8) - originTextLength + 1
  if (diffNum) {
    for (let i = 0; i < diffNum; i++) {
      originText.push('')
    }
  }
  return originText
}

function createmSourceTextMeasureWidths (getMeasureTextWidth, maxSourceText, col, delimiter) {
  const maxSourceTextList = pathchLevels(maxSourceText, col)
  const maxSourceTextMeasureWidths = [...maxSourceTextList].reverse().map((val, i) => {
    const measureWidth = val ? parseInt(getMeasureTextWidth(val + (i > 0 ? String(delimiter) : ''))) : 0
    return {
      measureWidth,
      text: val,
      level: i - (maxSourceTextList.length - 1)
    }
  })
  return maxSourceTextMeasureWidths
}

export function useAutoWidgetPlugins (vm, { getMeasureTextWidth, createTextMap, reloadData, setCurrentDeptLevel } = {}) {
  vm._autoWidgetDraggingCols = null
  const setDraggingWidgetColumn = (col) => {
   try {
    const { textFlexWidget } = col || {}
    if (!textFlexWidget) {
      return
    }
    vm._autoWidgetDraggingCols = col
   } catch (error) {
    console.log(error)
   }
  }
  const clearAutoWidgetDraggingCols = () => {
    vm._autoWidgetDraggingCols = null
  }
  /**
   *
   * @description 计算伸缩部件渲染区间
   * @param {*} col
   */
  const calculateWidgetTextRange = (col) => {
    try {
      const { key, width, textFlexWidget, delimiter = '/' } = col
      if (!textFlexWidget) {
        return
      }
      const preCol = vm._autoWidgetDraggingCols
      if (!preCol) {
        return
      }
      const plus = preCol.width < width
      let autoLevel = null
      const { maxPaintText, maxSourceText } = createTextMap(vm, key, plus, getMeasureTextWidth)
      if (!maxSourceText || !maxPaintText) {
        return
      }
      const maxSourceTextMeasureWidths = createmSourceTextMeasureWidths(getMeasureTextWidth, maxSourceText, col, delimiter)
      if (!maxSourceTextMeasureWidths || !maxSourceTextMeasureWidths.length) {
        return
      }
      const maxSourceTextMeasureWidthsLength = maxSourceTextMeasureWidths.length
      let patchTextItemIndex = -1
      const currentMeasureWidthSum = parseInt(getMeasureTextWidth(maxPaintText)) + 12
      const maxPaintTextList = maxPaintText.split(delimiter)
      if (plus) {
        // 绘制的宽度小于实际宽度，说明需要补
        if (currentMeasureWidthSum < width && maxSourceTextMeasureWidthsLength) {
          let sum = 0
          let index = -1
          for (let i = 0; i < maxSourceTextMeasureWidthsLength; i++) {
            const { measureWidth } = maxSourceTextMeasureWidths[i]
            sum += measureWidth
            index = i
            if (sum >= width) {
              break
            }
          }
          if (index === (maxSourceTextMeasureWidthsLength - 1)) {
            patchTextItemIndex = index
            const lastText = maxPaintTextList[maxPaintTextList.length - 1]
            const diff = sum - width
            // 超过太多了就返回
            if (diff && diff > (parseInt(getMeasureTextWidth(lastText)) / 3)) {
              patchTextItemIndex = index - 1
            }
          } else {
            patchTextItemIndex = index - 1
          }
        }
      } else {
        let sum = 0
        for (let i = 0; i < maxSourceTextMeasureWidthsLength; i++) {
          const { measureWidth } = maxSourceTextMeasureWidths[i]
          sum += measureWidth
          if (sum <= width) {
            patchTextItemIndex = i
          } else {
            break
          }
        }
        if (patchTextItemIndex === -1 && sum > width) {
          patchTextItemIndex = 0
        }
      }
      let patchTextItem = maxSourceTextMeasureWidths[patchTextItemIndex]
      if (patchTextItem) {
        autoLevel = patchTextItem.level >= 0 ? 0 : patchTextItem.level
      }

      if (typeof autoLevel === 'number') {
        setCurrentDeptLevel(col, autoLevel, vm)
        reloadData()
      }
    } catch (error) {
      console.log(error)
    }
  }
  return {
    calculateWidgetTextRange,
    setDraggingWidgetColumn,
    clearAutoWidgetDraggingCols
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/widget/auto.js